<template>

    <div v-if="!modal.data && editMode && !hasNotPreview" class="add-link"><button @click="modal.show = true">{{ $t('linkPreview.ADD_LINK') }}<i class="material-icons">add_link</i></button></div>

    <template v-if="(!modal.show && modal.data) || (hasNotPreview && modal.data.previewUrl)">

        <div v-if="hasNotPreview" class="notPreview" :class="{'editMode': editMode}">
            <span v-if="props.editMode" class="delete" @click.stop="modal.data = null; modal.url = ''; hasNotPreview = false; emit('delete')">
                <i class="material-icons">delete</i>
            </span>
            <a :href="modal.data.previewUrl" target="_blank">{{modal.data.previewUrl}}</a>
        </div>
        
        <div v-else class="linkPreview">
            <span v-if="props.editMode" class="delete" @click.stop="modal.data = null; modal.url = ''; hasNotPreview = false; emit('delete')">
                <i class="material-icons">delete</i>
            </span>
            <a :href="modal.data.previewUrl" target="_blank">
                <h3>{{modal.data.title || ''}}</h3>
                <img v-if="modal.data.image" :src="modal.data.image">
                <h4>{{modal.data.description || ''}}</h4>
            </a>
        </div>

    </template>

    <div class="modal__overlay" v-if="modal.show">
        <div class="modal-linkPreview">
            <i class="material-icons modal-linkPreview__close" @click="modal.show = false; modal.url = ''">close</i>
            <h3>{{ $t('linkPreview.ADD_LINK') }}</h3>
            <input type="text" v-model="modal.url" :placeholder="$t('linkPreview.LINK_PLACEHOLDER')">
            <div class="modal-linkPreview__buttons">
                <button class="cancel" @click="modal.show = false; modal.url = ''">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click="getLinkPreview()" :disabled="loading">{{ $t('global.SAVE') }} <i class="material-icons">arrow_forward</i></button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { useStore } from 'vuex';
import { defineProps, defineEmits, onMounted, ref } from 'vue';

const store = useStore();
const props = defineProps({
    //url: String,
    data: Object,
    editMode: Boolean
});
const emit = defineEmits(['delete','generated']);

const modal = ref({
    show: false,
    url: '',
    data: null
})
const hasNotPreview = ref(false);
const loading = ref(false);

async function getLinkPreview() {
    loading.value = true;
    try {
        let req = await store.dispatch('stuff_linkPreview', { url: modal.value.url });
        // Chequear si previewUrl es null y tratarlo como error
        if (req.data.previewUrl === null) {
            throw new Error('PreviewURL es null');
        }
        modal.value.data = req.data;
    } catch (error) {
        hasNotPreview.value = true;
        modal.value.data = notPreviewModel;
        modal.value.data.previewUrl = modal.value.url;
    }
    finally {
        modal.value.show = false;
        emit('generated', modal.value.data);
        loading.value = false;
    }
}


const notPreviewModel = {
    description: null,
    image: null,
    imageHeight: null,
    imageWidth: null,
    locale: null,
    previewUrl: null,
    siteName: null,
    title: null,
    type: null
}


onMounted(()=>{
    if(props.data) {
        modal.value.data = props.data;
        if(!modal.value.data.image && !modal.value.data.description && !modal.value.data.title) hasNotPreview.value = true;
    }
})

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.modal-linkPreview{
    position: relative;
    width: 100%;
    max-width: 420px;
    padding: 36px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    background: #fff;
    border-radius: 10px;
    &__close{
        position: absolute;
        top: 12px;
        right: 12px;
        font-size: 28px;
        cursor: pointer;
    }
    h3{
        font-size: 16px;
        font-weight: 700;
    }
    input{
        height: 40px;
        padding: 0px 29px 0px 28px;
        background: #F6F6F6;
        //background: red;
        border-radius: 50px;
        border: none;
    }
    &__buttons{
        padding-top: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 36px;
        .cancel{
            color: $green;
            font-weight: 600;
        }
        .confirm{
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 7px 22px;
            background: $green;
            color: #fff;
            font-weight: 600;
            border-radius: 44px;
            &:disabled{
                opacity: .6;
                cursor: default;
            }
        }
    }
}

.add-link{
    button{
        padding: 0 12px 1px 12px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        font-weight: 500;
        background: $green;
        color: #fff;
        border-radius: 12px;
        i{
            font-size: 23px;
        }
    }
}

.linkPreview{
    position: relative;
    padding: 5px 8px;
    border: 1px solid #e9e5e5;
    border-radius: 4px;
    background: #fff;
    a{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .delete{
        position: absolute;
        top: 12px;
        right: 12px;
        padding: 3px 4px 0px 4px;
        border-radius: 12px;
        background: $green;
        cursor: pointer;
        color: #fff;
        z-index: 2;
    }
    img{
        width: 100%;
        object-fit: contain;
        border-radius: 4px;
    }
    h3,h4{
        display: -webkit-box;
        -webkit-line-clamp: 2; /* Limita el texto a 2 líneas */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        /* Añade estos estilos para mayor compatibilidad */
        max-height: 2.4em; /* Establece la altura máxima para 2 líneas de texto */
        line-height: 1.2em; /* Establece la altura de línea para un mejor control del corte */
        white-space: normal;

    }
    h3{
        font-size: 12px;
    }
    h4{
        font-size: 12px;
        font-weight: 500;
    }
}

.notPreview{
    position: relative;
    width: 100%;
    &.editMode{
        padding: 12px 4px;
        background: #fff;
        border: 1px solid #e9e5e5;
        border-radius: 4px;
    }
    .delete{
        position: absolute;
        top: 16%;
        right: 8px;
        padding: 3px 4px 0px 4px;
        border-radius: 12px;
        background: $green;
        cursor: pointer;
        color: #fff;
        z-index: 2;
    }
    a{
        display: block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;  
        text-overflow: ellipsis;
        color: #1A23FA;
        text-decoration: underline;
    }
}


</style>